import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router"
import IconButton from '@mui/material/IconButton'
import { Container, Button, Grid, Typography, Checkbox, FormControlLabel, FormHelperText, Snackbar, Box, Card, CardContent } from "@mui/material"
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import InputAdornment from '@mui/material/InputAdornment'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import { Person, VpnKey, Email } from '@mui/icons-material'
import validator from 'validator'
import { useSnackbar } from '../providers/SnackbarProvider'
import { useConfirmationDialog } from '../providers/ConfirmationDialogProvider';

export default function EditUser(props) {
    const [name, setName] = useState()
    const [password, setPassword] = useState("")
    const [nameError, setNameError] = useState(false)

    const [passwordError, setPasswordError] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [passwordErrorText, setPasswordErrorText] = useState("")

    const [nameErrorText, setNameErrorText] = useState("")

    const [confirmation, setConfirmation] = useState("")
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false)
    const [confirmationError, setConfirmationError] = useState(false)
    const [passwordConfirmationText, setPasswordConfirmationText] = useState("")

    const [email, setEmail] = useState(props.user.email === "" ? "" : props.user.email)
    const [emailError, setEmailError] = useState(false)
    const [emailErrorText, setEmailErrorText] = useState("")

    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState("")
    const [rolesError, setRolesError] = useState(false)
    const [rolesErrorText, setRolesErrorText] = useState("")

    // Garante fallback para todas as permissões, evitando destructuring de null/undefined
    const [userRolesList, setUserRolesList] = useState({
        upload: false,
        editar: false,
        alarmes: false,
        relatorio: false,
        usuarios: false,
        admin: false,
        revenda: false,
        delta: false,
        notEditable: false,
        tecnico: false,
        light: false,
        multiCentral: false,
        ...(props.user.role || {})
    })

    const history = useHistory()
    const { openSnackbar } = useSnackbar()
    const { openConfirmationDialog } = useConfirmationDialog();

    const [loadingAction, setLoadingAction] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const { upload, editar, alarmes, relatorio, usuarios, admin, revenda, delta } = userRolesList

    const isIntegrator = !!props.user.role?.revenda;
    const isTecnico = !!props.user.role?.tecnico;
    const gridInput = isTecnico ? 4 : 12;
    const gridCheck = isTecnico ? 4 : 6;
    const isSelf = props.user.id === props.loggedUser?.id;
    const loggedRole = props.loggedUser?.role || props.loggedUser?.roles || {};
    const isFullAdmin = !!(loggedRole.upload && loggedRole.usuarios && loggedRole.alarmes &&
        loggedRole.relatorio && loggedRole.editar);
    const loggedIsAdmin = isFullAdmin;
    const canEditPermissions = isFullAdmin;

    const handleRoles = (event) => {
        setUserRolesList({
            ...userRolesList,
            [event.target.name]: event.target.checked,
        })
    }

    useEffect(() => {
        setName(props.user.dS_NOME || props.user.DS_NOME || "")
        setDisabled(props.user.role?.notEditable || false)

        if (isIntegrator) {
            setDisabled(true)
        }
    }, [])

    const handleSubmit = async(e) => {
        e.preventDefault();
        setLoadingAction('save');
        setIsLoading(true);

        if (name.length < 1) {
            setNameError(true)
            setNameErrorText("Insira o nome do usuário")
        } else {
            setNameError(false)
            setNameErrorText("")
        }

        if (password.length < 8 && password.length > 0) {
            setPasswordError(true)
            setPasswordErrorText("Sua senha deve conter no mínimo 8 caracteres")
        } else {
            setPasswordError(false)
            setPasswordErrorText("")
        }

        if (confirmation !== password) {
            setConfirmationError(true)
            setPasswordConfirmationText("As senhas devem ser iguais")
        } else {
            setConfirmationError(false)
            setPasswordConfirmationText("")
        }

        if (email != null) {
            if (validator.isEmail(email)) {
                setEmailError(false)
                setEmailErrorText("")

            } else {
                setEmailError(true)
                setEmailErrorText("Insira um email válido")
            }
        }

        const allowedRoles = ['upload', 'usuarios', 'alarmes', 'relatorio', 'editar'];
        const hasAnyRole = allowedRoles.some(r => userRolesList[r] === true);
        if (!hasAnyRole) {
            setRolesError(true)
            setRolesErrorText("Selecione ao menos uma permissão para o usuário")
        } else {
            setRolesError(false)
            setRolesErrorText("")
        }

        if (passwordError === false && name && confirmation === password && emailError === false && hasAnyRole)
        {
            try {
                const response = await fetch(`${process.env.REACT_APP_URL}/user/edit`, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify({
                        "ID": props.user.id,
                        "EMAIL": email,
                        "DS_NOME": name,
                        "SENHA": password,
                        "ROLE": userRolesList,
                        "ID_EMPRESA": props.user.companyId || props.user.iD_EMPRESA,
                        "ID_INTRANET": props.user.intranetId || props.user.iD_INTRANET,
                        "DS_CNPJ": props.user.cnpj || props.user.dS_CNPJ
                    })
                });

                if (await !response.ok)
                {
                    throw new Error("Erro ao editar usuário");
                }
                const data = await response.json();
                openSnackbar("✅ Usuário atualizado com sucesso! As alterações foram salvas no sistema.", "success");
                setPassword("");
                setConfirmation("");

                let updatedUser = {...props.user, dS_NOME: name, email: email, role: userRolesList};

                if (props.onUserUpdated) props.onUserUpdated(updatedUser);
                if (props.onEditFinished) props.onEditFinished();
            } catch (error) {
                console.error("ERROR AO EDITAR USUÁRIO: ", error);
                openSnackbar("❌ Não foi possível editar o usuário. Verifique os dados e tente novamente.", "error");
            } finally {
                setIsLoading(false);
            }
        }
        else {
            setIsLoading(false);
        }
    }

    const handleDelete = async () => {
        openConfirmationDialog({
            title: "Excluir Usuário",
            message: `Tem certeza que deseja excluir o usuário ${props.user.dS_NOME}?`,
            confirmButtonText: "Excluir",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "error",
            onConfirm: async () => {
                try {
                    setLoadingAction('delete');
                    setIsLoading(true);
                    const response = await fetch(`${process.env.REACT_APP_URL}/user/delete?userId=${props.user.id}`, {
                        method: "GET",
                        headers: { "content-type": "application/json" }
                    });
                    const data = await response.json();
                    props.removeUser(data.user);
                    openSnackbar("✅ Usuário excluído com sucesso! O acesso foi removido do sistema.", "success");
                } catch (error) {
                    console.error("ERROR AO DELETAR USUÁRIO: ", error);
                    openSnackbar("❌ Não foi possível excluir o usuário. Tente novamente mais tarde.", "error");
                } finally {
                    setIsLoading(false);
                }
            },
            onCancel: () => {
                return;
            }
        });
    }

    const setVisible = () => {
        setShowPassword(!showPassword)
    }

    const setConfirmationVisible = () => {
        setShowPasswordConfirmation(!showPasswordConfirmation)
    }

    const validateEmail = (e) => {
        if (validator.isEmail(e)) {
            setEmailError(false)
            setEmailErrorText("")

        } else {
            setEmailError(true)
            setEmailErrorText("Insira um email válido")
        }
        setEmail(e)
    }

    return (
        <Box sx={{
            '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
            '& .MuiOutlinedInput-root': {
                color: '#fff',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(52,152,219,0.35)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(52,152,219,0.65)' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3498DB' },
                '& .MuiInputBase-input.Mui-disabled': { color: 'rgba(255,255,255,0.45)', WebkitTextFillColor: 'rgba(255,255,255,0.45)' }
            },
            '& .MuiInputAdornment-root .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.5)' },
            '& .MuiFormHelperText-root': { color: 'rgba(255,255,255,0.45)' },
            '& .MuiFormHelperText-root.Mui-error': { color: '#FF3B30' },
            '& .MuiFormControlLabel-label': { color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' },
            '& .MuiCheckbox-root': { color: 'rgba(52,152,219,0.6)' },
            '& .MuiCheckbox-root.Mui-checked': { color: '#3498DB' },
            '& .MuiIconButton-root': { color: 'rgba(255,255,255,0.6)' }
        }}>
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                { !isIntegrator ?
                    <Grid item xs={12} md={12} lg={gridInput}>
                        <InputLabel htmlFor="usern-name">Nome do usuário</InputLabel>
                        <OutlinedInput
                            autoFocus={true}
                            id="usern-name"
                            onChange={(e) => setName(e.target.value)}
                            variant="outlined"
                            color="secondary"
                            required
                            value={name}
                            error={nameError}
                            fullWidth={true}
                            disabled={disabled || isLoading}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Person />
                                </InputAdornment>
                            }
                        ></OutlinedInput>
                        <FormHelperText id="user-name">{nameErrorText}</FormHelperText>
                    </Grid>
                    : null
                }

                {props.user.email != null ?
                    <Grid item xs={12} md={12} lg={12}>
                        <InputLabel htmlFor="email-field">E-mail</InputLabel>
                        <OutlinedInput
                            type="email"
                            id="email-field"
                            variant="outlined"
                            color="secondary"
                            fullWidth={true}
                            value={email}
                            placeholder="Insira um email válido para este usuário"
                            error={emailError}
                            required
                            disabled={disabled || isLoading}
                            onChange={(e) => validateEmail(e.target.value)}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Email />
                                </InputAdornment>
                            }
                        ></OutlinedInput>
                        <FormHelperText id="email-field">{emailErrorText}</FormHelperText>
                    </Grid>
                    : null}

                <Grid item xs={12} md={12} lg={gridInput}>
                    <InputLabel htmlFor="outlined-adornment-password">Nova senha</InputLabel>
                    <OutlinedInput
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        id="password"
                        type={showPassword ? "text" : "password"}
                        error={passwordError}
                        value={password}
                        fullWidth={true}
                        disabled={disabled || isLoading}
                        startAdornment={
                            <InputAdornment position="start">
                                <VpnKey />
                            </InputAdornment>
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={setVisible}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText id="password">Deixe em branco caso não queira trocar de senha</FormHelperText>
                    <FormHelperText id="password">{passwordErrorText}</FormHelperText>
                </Grid>

                <Grid item xs={12} md={12} lg={gridInput}>
                    <InputLabel htmlFor="outlined-adornment-password">Confirme a nova senha</InputLabel>
                    <OutlinedInput
                        required
                        onChange={(e) => setConfirmation(e.target.value)}
                        id="confirmation"
                        type={showPasswordConfirmation ? "text" : "password"}
                        error={confirmationError}
                        value={confirmation}
                        fullWidth={true}
                        disabled={disabled || isLoading}
                        startAdornment={
                            <InputAdornment position="start">
                                <VpnKey />
                            </InputAdornment>
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={setConfirmationVisible}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText id="password">{passwordConfirmationText}</FormHelperText>
                </Grid>

                {/* {userNotFound == false ? null : <Grid item xs={12} md={12} lg={12}><Typography variant='body2' color='#d32f2f'>Usuário e/ou senha incorretos</Typography></Grid>} */}

            </Grid>

            {
                !isIntegrator ?
                        <Grid sx={{ marginTop: "15px"}} container spacing={2}>
                            <Grid justifyContent="center" alignItems="center" item xs={12} md={12} lg={12}>
                                <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', fontWeight: 500, letterSpacing: '0.3px' }}>Editar permissões</Typography>
                                {rolesError && <Typography sx={{ fontSize: '11px', color: '#FF3B30', mt: 0.5 }}>{rolesErrorText}</Typography>}
                            </Grid>

                            {[
                                { name: 'upload',    label: 'Upload .ROM',               checked: upload },
                                { name: 'usuarios',  label: 'Criar Usuários',            checked: usuarios },
                                { name: 'alarmes',   label: 'Gerar Comandos',             checked: alarmes },
                                { name: 'relatorio', label: 'Gerar Relatórios',           checked: relatorio },
                                { name: 'editar',    label: 'Editar Grupos / Amplif.',   checked: editar },
                            ].map(({ name, label, checked }) => (
                                <Grid item xs={6} sm={4} md={4} lg={gridCheck} key={name}>
                                    <Card
                                        onClick={() => canEditPermissions && !disabled && !isLoading && handleRoles({ target: { name, checked: !checked } })}
                                        sx={{
                                            borderRadius: '12px',
                                            border: checked
                                                ? '2px solid rgba(52,152,219,0.75)'
                                                : '2px solid rgba(255,255,255,0.12)',
                                            background: checked
                                                ? 'linear-gradient(135deg, rgba(52,152,219,0.18) 0%, rgba(44,62,80,0.97) 100%)'
                                                : 'linear-gradient(135deg, rgba(26,37,47,0.97) 0%, rgba(44,62,80,0.97) 100%)',
                                            cursor: !canEditPermissions || disabled || isLoading ? 'not-allowed' : 'pointer',
                                            opacity: disabled ? 0.5 : !canEditPermissions ? 0.65 : 1,
                                            transition: 'all 0.2s ease',
                                            '&:hover': !canEditPermissions || disabled || isLoading ? {} : {
                                                borderColor: checked ? 'rgba(52,152,219,0.95)' : 'rgba(255,255,255,0.3)',
                                                transform: 'translateY(-1px)',
                                                boxShadow: checked ? '0 4px 12px rgba(52,152,219,0.25)' : '0 2px 8px rgba(0,0,0,0.3)'
                                            }
                                        }}
                                    >
                                        <CardContent sx={{ padding: '10px 12px !important', textAlign: 'center' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={checked}
                                                        onChange={handleRoles}
                                                        name={name}
                                                        disabled={!canEditPermissions || disabled || isLoading}
                                                        size="small"
                                                        onClick={(e) => e.stopPropagation()}
                                                        sx={{
                                                            padding: '2px',
                                                            color: checked ? '#3498DB' : 'rgba(255,255,255,0.4)',
                                                            '&.Mui-checked': { color: '#5ACBFA' }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Typography variant="caption" sx={{
                                                        fontWeight: checked ? 700 : 400,
                                                        color: checked ? '#fff' : 'rgba(255,255,255,0.65)',
                                                        lineHeight: 1.2
                                                    }}>{label}</Typography>
                                                }
                                                sx={{ margin: 0, gap: '4px' }}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    : null
            }

            <Grid sx={{ marginTop: "15px"}} container spacing={2}>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
                    {loggedIsAdmin && !isSelf && (
                    <Button 
                        variant="contained" 
                        color="error"
                        onClick={handleDelete} 
                        disabled={disabled || isLoading} 
                        sx={{ 
                            mr: "20px",
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '0.95rem',
                            fontWeight: 500,
                            textTransform: 'none',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)'
                            }
                        }} 
                    >
                        {loadingAction === 'delete' ? "Excluindo..." : "Excluir"}
                    </Button>
                    )}
                    <Button 
                        variant="contained" 
                        color="secondary"
                        onClick={handleSubmit} 
                        disabled={disabled || isLoading}
                        sx={{
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '0.95rem',
                            fontWeight: 500,
                            textTransform: 'none',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                            }
                        }}
                    >
                        {loadingAction === 'save' ? "Salvando..." : "Salvar"}
                    </Button>
                </Grid>
            </Grid>
        </form>
        </Box>
    );
}